import { Modules, useConfig } from 'scbk-services/config';
import { RedirectOptions } from 'scbk-services/types/route/route';
import { useRouterRegistry } from '../stores/routerRegistryStore';
import { useRouter } from './useRouter';
import { useRouterHistory } from '../stores/routerHistoryStore';
import { useRedirectStore } from '../stores/redirectStore';

/**
 * 리다이렉션 처리
 */
const useRedirect = () => {
    const router = useRouter();
    const { findModuleRouteObjectsByPath } = useRouterRegistry.getState();
    const { peekRoute } = useRouterHistory();
    const { setRedirectInfo } = useRedirectStore();
    const { getConfig } = useConfig();

    /**
     * 이동할 페이지에 전달할 리다이렉션 정보를 생성한다.
     * @param options
     */
    const createRedirectInfo = (options?: RedirectOptions) => {
        const fromRouteObject = peekRoute();
        if (fromRouteObject) {
            setRedirectInfo({
                pageId: fromRouteObject?.id ?? '',
                routeData: fromRouteObject?.routeData ?? {},
                cause: options?.cause,
                query: options?.query,
            });
        }
    };

    /**
     *
     * @param pageId
     * @param options
     */
    const redirectTo = (pageId: string, options?: RedirectOptions) => {
        //리다이렉트 발생시긴 화면정보를 router history 에서 가져와, redirect 정보 store에 저장한다.
        createRedirectInfo(options);

        router.push(pageId, {
            ...options,
            ...(options?.cause && { query: `cause=${options?.cause}` }),
        });
    };

    /**
     * 로그인페이지로 이동한다.
     * 로그인 페이지로 이동하기 전 로그인 성공이후 리다이렉션 정보를 store에 저장한다.
     * @param options
     */
    const redirectToLogin = (options?: RedirectOptions) => {
        const loginRoute = getConfig(Modules.COMMON).loginRoute;
        const findRouteObject = findModuleRouteObjectsByPath(loginRoute);
        if (!findRouteObject) {
            return;
        }

        const loginPageId = findRouteObject.id as string;
        redirectTo(loginPageId, { ...options });
    };

    return {
        redirectTo,
        redirectToLogin,
    };
};

export { useRedirect };
